/*
[PU-698] - temporary solution for getting prices from pet optional extra object.
Refactoring BE prices will take a  lot of time, so in order to make it work were decided to handle it on FE
Ideally we should get just a Number in 'extra.value'
 */
export const getExtrasPrice = (extra, doNotCovertDescription = false) => {
  if (!extra) return null;
  // get price from optional extra object
  let price = null;
  switch (true) {
    // Case for price received in extra.valueAsText eg. '1 million' (PU-4228)
    case 'valueAsText' in extra:
      if (extra.valueAsText) return extra.valueAsText;
      break;
    case 'value' in extra:
      price = extra.value;
      break;
    case 'cost' in extra:
      price = extra.cost;
      break;
    case extra.cost && 'value' in extra.cost:
      price = extra.cost.value;
      break;
    case 'description' in extra: // some products have "Unlimited" price or has test description which come in description field
      price = extra.description;
      if (doNotCovertDescription && price) return price;
      break;
    case extra.cost && 'description' in extra.cost:
      price = extra.cost.description;
      if (doNotCovertDescription && price) return price;
      break;
  }

  if (price === null) {
    return 'Ask provider';
  }

  // remove non-numeric characters from price
  let parsedPrice = price.toString().replace(/[^0-9.]/g, '');
  parsedPrice = parseFloat(parsedPrice);

  if (isNaN(parsedPrice)) {
    return price;
  }

  return '£' + parsedPrice;
};
